module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_28.be2cb891.pdf";